// SPDX-License-Identifier: AGPL-3.0-or-later

// Micup: names and thresholds an empty or invalid instance setting falls back to; admins edit both per tier.
export const DEFAULT_STAFF_BADGE_TIERS = [
	{tr: 'Stajyer', en: 'Intern'},
	{tr: 'Gönüllü', en: 'Volunteer'},
	{tr: 'Destek', en: 'Support'},
	{tr: 'Destek Uzmanı', en: 'Support Specialist'},
	{tr: 'Moderatör', en: 'Moderator'},
	{tr: 'Kıdemli Moderatör', en: 'Senior Moderator'},
	{tr: 'Baş Moderatör', en: 'Head Moderator'},
	{tr: 'Topluluk Yöneticisi', en: 'Community Manager'},
	{tr: 'Ekip Lideri', en: 'Team Lead'},
	{tr: 'Yönetici', en: 'Administrator'},
	{tr: 'Baş Yönetici', en: 'Head Administrator'},
	{tr: 'Kurucu', en: 'Founder'},
] as const;

// threshold is the distinct server count a tier starts at; tier 1 starts at the first counted server.
export const DEFAULT_BOT_DEVELOPER_BADGE_TIERS = [
	{tr: 'Bot Geliştirici', en: 'Bot Developer', threshold: 1},
	{tr: 'Çırak Geliştirici', en: 'Apprentice Developer', threshold: 5},
	{tr: 'Usta Geliştirici', en: 'Skilled Developer', threshold: 25},
	{tr: 'Uzman Geliştirici', en: 'Expert Developer', threshold: 100},
	{tr: 'Mimar', en: 'Architect', threshold: 500},
	{tr: 'Efsane Geliştirici', en: 'Legendary Developer', threshold: 2500},
	{tr: 'Bot Ustası', en: 'Bot Master', threshold: 10000},
] as const;

export const DEFAULT_BOT_DEVELOPER_MIN_MEMBERS = 5;
